module.exports = __webpack_public_path__ + "media/en_au_s2_Ethan.f9372453.mp3";